export default __webpack_public_path__ + "static/media/Logout.173c7a0e.svg";